module.exports = __webpack_public_path__ + "img/lothar.5dd2c42d.jpg";